import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeleteBookmarkMutationVariables = Types.Exact<{
  input: Types.DeleteBookmarkInput;
}>;


export type DeleteBookmarkMutation = { deleteBookmark: { bookmark?: { id: string, entity?: { id: string, bookmark?: { id: string } | null } | { id: string, bookmark?: { id: string } | null } | { id: string, bookmark?: { id: string } | null } | { id: string, bookmark?: { id: string } | null } | { id: string, bookmark?: { id: string } | null } | { id: string, bookmark?: { id: string } | null } | { id: string, bookmark?: { id: string } | null } | { id: string, bookmark?: { id: string } | null } | { id: string, bookmark?: { id: string } | null } | { id: string, bookmark?: { id: string } | null } | { id: string, bookmark?: { id: string } | null } | { id: string, bookmark?: { id: string } | null } | {} | null } | null } };


export const DeleteBookmarkDocument = /*#__PURE__*/ gql`
    mutation deleteBookmark($input: DeleteBookmarkInput!) {
  deleteBookmark(input: $input) {
    bookmark {
      id
      entity {
        ... on PathContentType {
          id
          bookmark {
            id
          }
        }
        ... on TaskContentType {
          id
          bookmark {
            id
          }
        }
        ... on CourseContentType {
          id
          bookmark {
            id
          }
        }
        ... on CheckinType {
          id
          bookmark {
            id
          }
        }
        ... on ExerciseType {
          id
          bookmark {
            id
          }
        }
        ... on QuizContentType {
          id
          bookmark {
            id
          }
        }
        ... on ExternalContentType {
          id
          bookmark {
            id
          }
        }
        ... on ScormContentType {
          id
          bookmark {
            id
          }
        }
        ... on ArticleContentType {
          id
          bookmark {
            id
          }
        }
        ... on SurveyContentType {
          id
          bookmark {
            id
          }
        }
        ... on MicroLearningContentType {
          id
          bookmark {
            id
          }
        }
        ... on RoleplayContentType {
          id
          bookmark {
            id
          }
        }
      }
    }
  }
}
    `;

export function useDeleteBookmarkMutation() {
  return Urql.useMutation<DeleteBookmarkMutation, DeleteBookmarkMutationVariables>(DeleteBookmarkDocument);
};